module.exports = __webpack_public_path__ + "img/edeel@2x.44bae56f.png";